import PropTypes from 'prop-types';
import { noop } from '../../../utils/noop';
import FacetsLink from '../../FacetsLink/FacetsLink';
import { singleSelectStyle } from './SingleSelect.style';

const SingleSelect = ({ item, onFacetChange, isFacetCountHidden }) => {
  let filterName = '';
  item.values.forEach((value) => {
    const filters = value?.filters || [];
    filterName = filters.find((f) => /_category_paths/.test(f.name))?.name || '';
  });
  return (
    <ul data-facet-type={filterName} className="singleselect">
      {item.values.map((value, index) => {
        const { title, url, count, facetType } = value;
        return (
          <li key={JSON.stringify(`${title}-${index}`)}>
            <FacetsLink
              title={title}
              onFacetChange={() => {
                onFacetChange(url, value);
              }}
              count={count}
              isFacetCountHidden={isFacetCountHidden}
              facetType={facetType}
            />
          </li>
        );
      })}
      <style jsx>{singleSelectStyle}</style>
    </ul>
  );
};

SingleSelect.defaultProps = {
  onFacetChange: noop,
  isFacetCountHidden: false,
};

SingleSelect.propTypes = {
  item: PropTypes.object.isRequired,
  onFacetChange: PropTypes.func,
  isFacetCountHidden: PropTypes.bool,
};

export { SingleSelect };
